import { emailTemplateSchema } from "@redotech/redo-marketing-templates-common/email-template";
import * as z from "zod";

export const getEmailTemplates = {
  name: "getEmailTemplates" as const,
  input: z.object({}),
  output: z.array(emailTemplateSchema),
};
